export const languageNames = {
  "languageName.en": "English",
  "languageName.fr": "Français",
};
